<template>
  <div>
    <b-row class="m-0 pt-3 justify-content-center" style="margin-top: 50px !important">
      <div style="position: relative">
        <b-img-lazy :src="require(`@/assets/logos/eatDoradoLogo.png`)" class="ml-3" style=" max-width: 90%; width: 300px; height: 200px" fluid alt="eatDorado Logo"></b-img-lazy>  
        <p class="text-center" style="position: absolute; right: -50px; bottom: -30px; font-size: 20px; transform: rotate(-10deg);" >#supportyourlocals!</p>
      </div>  
    </b-row>
    
    <b-row class="m-0 mt-4 justify-content-center">
      <div style="width: 1200px; max-width: 100%; " >
        <b-row class="m-0 justify-content-center" >
          <div style="width: 400px; max-width: 90%">
            <google-places-autocomplete/>
          </div>
        </b-row>
      <b-row class="m-0 my-2 mt-5 justify-content-center">
        <div>
          <h1 class="text-center">Du hast die Wahl, bestell' lokal!</h1>
        </div>
      </b-row>

        <b-row class="m-0 pt-3 pb-5 justify-content-center" style="">
          <b-col cols="12" md="6">
            <div class="m-5">
              <b-row class="m-0 justify-content-center">
                <b-img-lazy :src="require(`@/assets/images/undraw_my_location.svg`)" style="height: 200px" fluid alt="eatDorado Logo"></b-img-lazy>  
              </b-row>
              <h4 class="text-center mt-4">1. Entdecke Restaurants in Deiner Nähe und somit allerlei Köstlichkeiten.</h4>
            </div>
          </b-col>
          <b-col cols="12" md="6">
            <div class="m-5">
              <b-row class="m-0 justify-content-center">
                <b-img-lazy :src="require(`@/assets/images/undraw_Hamburger.svg`)" style="height: 200px" fluid alt="eatDorado Logo"></b-img-lazy>  
              </b-row>
              <h4 class="text-center mt-4">2. Bestell' Deine Lieblingsspeisen ganz einfach in dem Restaurant deiner Wahl zum Liefern oder Abholen.</h4>
            </div>
          </b-col>
          <b-col cols="12" md="6" style="z-index: 101">
            <div class="m-5" >
              <b-row class="m-0 justify-content-center">
                <b-img-lazy :src="require(`@/assets/images/undraw_On_the_way.svg`)" style="height: 200px" fluid alt="eatDorado Logo"></b-img-lazy>  
              </b-row>
              <h4 class="text-center mt-4">3. Hole Deine Bestellung vor Ort beim Restaurant ab oder lasse sie Dir liefern, bezahle und genieße!</h4>
            </div>
          </b-col>

          <b-col cols="12" md="6" style="z-index: 101">
            <div class="m-5" >
              <b-row class="m-0 justify-content-center">
                <b-img-lazy :src="require(`@/assets/images/undraw_heart.svg`)" style="height: 200px" fluid alt="eatDorado Logo"></b-img-lazy>  
              </b-row>
              <h4 class="text-center mt-4">Mit jeder Bestellung unterstützt Du die Restaurants in Deiner Nähe! Ganz nach dem Motto: </h4>
              <h4 class="text-center" style="transform: rotate(-5deg);">#supportyourlocals</h4>
            </div>
          </b-col>
          
        </b-row>
        <b-row class="m-0 mt-5 justify-content-center" v-if="company">
        
          <div class="w-100">
            <h3 class="text-center">Neueste eatDorados:</h3>
          </div>

        </b-row>

        <b-row class="m-0 justify-content-center" v-if="company">
          <div class="bg-white m-3 hover shadow p-2" style="border-radius: 20px; width: 900px; max-width: 100%" v-for="restaurant in company.slice(0,3)" :key="restaurant.index" @click="$router.push('/my/'+ restaurant._id).catch(err => {})">
            <b-row class="m-0">
              <b-col cols="6">
                <div>
                  <h5 class="mt-2">{{restaurant.title}}</h5>
                  <p class="m-0 mt-3">{{restaurant.adress.street}}</p>
                  <p class="m-0">{{restaurant.adress.zipcode}}, {{restaurant.adress.city}}</p>
                  
                </div>
                
              </b-col>
              <b-col cols="6">
                <div class="text-center">
                  <b-img-lazy :src="getImage(restaurant.img.image)" style="max-width:170px;max-height:200px;width: auto;height: auto; " fluid alt="eatDorado Logo"></b-img-lazy>  
                </div>
              </b-col>
            </b-row>
          </div>
        </b-row>

        <b-row class="m-0 mb-5 pb-5 justify-content-center">
        
          <div class="w-100">
            <h5 class="text-center">Willkommen bei eatDorado!</h5>
          </div>

        </b-row>

        <b-row class="m-0 mt-5 justify-content-center">
        
          <div class="w-100">
            <h3 class="text-center">Häufige Fragen:</h3>
          </div>

        </b-row>

        <b-row class="m-0 justify-content-center">
          <div class="bg-white m-3 shadow p-4" style="border-radius: 20px; width: 900px; max-width: 100%">
            <div class="mb-4">
              <h5>Warum kann ich hier nicht online bezahlen?</h5>
              <p>Eine Online-Zahlung ist mit erheblichem Verwaltungsaufwand und Kosten verbunden. Um den Restaurants so wenig wie möglich Kosten zu verursachen, verzichten wir bewusst auf diese Funktion.</p>
              <p>Die meisten Restaurants bieten auch vor Ort eine kontaktlose Zahlung an.</p>
            </div>
            <div class="mb-4">
              <h5>Warum muss ich meine Handynummer bei der Bestellung angeben?</h5>
              <p>Für die Bestätigung Deiner Bestellung bekommst Du einen Code per SMS zugesendet, dieser dient zur Verifizierung Deiner Handynummer - falls Dein gewähltes Restaurant Fragen zu Deiner Bestellung hat.</p>
              <p>Außerdem bekommst du von Deinem Restaurant einen Link per SMS geschickt, mit dem Du Deine Bestellung im Auge behalten kannst.</p>
            </div>
            <div class="mb-4">
              <h5>Mein Code hat nicht funktioniert!</h5>
              <p>Das ist natürlich ärgerlich! Bestellungen werden dem Restaurant nur zugestellt, wenn Du erfolgreich Deinen Code bestätigt hast.</p>
              <p>Solltest Du also nicht zu Deiner Bestellübersicht weitergeleitet worden sein, kannst Du einfach neu bestellen.</p>
            </div>
            <div class="mb-4">
              <h5>Wie kann ich eatDorado weiterempfehlen?</h5>
              <p>Unter diesem <span class="text-info custom-nav" @click="$router.push('/empfehlung').catch(err => {})">Link</span> findest Du ein Formular. Damit kannst Du Dein Lieblingsrestaurant empfehlen.</p>
            </div>
            <div class="mb-4">
              <h5>Wie kann ich Lob oder Kritik äußern?</h5>
              <p>Sende uns einfach eine E-Mail an diese Adresse: <a href="mailto:info@eatdorado.de">info@eatDorado.de</a></p>
              <p>Wir freuen uns auf Deine Nachricht!</p>
            </div>
          </div>
        </b-row>

      </div>
    </b-row>
    
    <b-modal id="loginModal" size="" centered v-model="loginModal" title="BootstrapVue" hide-footer hide-header>
      <div class="bg-white" style="border-radius: 10px; transition: all .5s;">
        <b-row class="m-0 linear-warning pt-3 pr-3 justify-content-end" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <font-awesome-icon @click="loginModal = false" style="font-size: 37px; cursor: pointer" :icon="['fas', 'times']"/>
        </b-row>
        <b-row class="m-0 linear-warning justify-content-center" >
        <h2 class="text-center text-dark" >mein eatDorado</h2>
        </b-row>
        <b-row class="m-0 pt-3 linear-warning triangle-modal justify-content-between">
          
        </b-row>
        <b-row class="m-0 justify-content-around" style="position: relative; top: -4vh">
          <b-form @submit.prevent="onSubmit" style="width: 90%">
            <b-form-group
              v-if="registerActive"
              id="input-group-1"
              label="Name:"
              label-for="input-1"
             
            >
              <b-form-input
                :state="!form.name ? false : true"
                id="input-1"
                v-model="form.name"
                type="text"
                placeholder="Name eingeben"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-2"
              label="E-Mail-Addresse:"
              label-for="input-2"
            >
              <b-form-input
                :state="!form.email ? false : true"
                id="input-2"
                v-model="form.email"
                type="email"
                placeholder="E-Mail eingeben"
                required
              ></b-form-input>
            </b-form-group>
          <b-form-group id="input-group-3" label="Passwort" label-for="input-3">
            <b-form-input
              :state="!form.password ? false : true"
              id="input-3"
              v-model="form.password"
              placeholder="Passwort eingeben..."
              type="password"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group v-if="registerActive" id="input-group-4" label="Passwort wiederholen" label-for="input-4">
            <b-form-input
              :state="!form.passwordRepeat ? false : true"
              id="input-4"
              v-model="form.passwordRepeat"
              placeholder="Passwort wiederholen..."
              type="password"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group v-if="registerActive" id="input-group-5">
            <b-form-checkbox-group
              :state="!form.checked > 0 ? false : true"
              v-model="form.checked"
              id="checkboxes-4"
              required
            >
              <b-form-checkbox value="me"><a href="/datenschutz" target="_blank">Datenschutz</a> gelesen und akzeptiert</b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
          <b-button type="submit" style="width: 100%" size="md" variant="dark">{{ registerActive ? 'registrieren' : 'anmelden' }}</b-button>
          <b-button style="width: 100%" size="md" class="mt-3" variant="outline-dark" @click="registerActive = !registerActive">{{ registerActive ? 'einloggen' : 'Account erstellen' }} </b-button>
          </b-form>
          
        </b-row>
        
      </div>
    </b-modal>
    <Footer style="margin-bottom: 130px !important"/>
  </div>
</template>

<script>

import Footer from '@/components/Footer'
import coreData from '@/mixins/coreDataMixin'
import GooglePlacesAutocomplete from './components/GooglePlacesAutocomplete'
export default {
  name: 'Home',
  mixins: [coreData],
  data: () => {
    return {
      form: {},
      loginModal: false,
      registerActive: false
    }
  },

  components: {
    Footer,
    GooglePlacesAutocomplete
  },
  computed: {
    darkMode(){
      return this.$store.getters.darkMode
    },
    company(){
      return this.$store.getters.company
    }
  },

  mounted() {

  },
  methods: {
    login(){
      var payload = {
        email: this.form.email,
        password: this.form.password
      }
      this.$store.dispatch('login', payload)
    }
  }
}
</script>